export default "__VITE_PUBLIC_ASSET__56b73b7e__"